import {
  CHANNEL_API_RESPONSE_SUCCESS,
  CHANNEL_API_RESPONSE_ERROR,
  UPDATE_CHANNEL_LOADING,
  RESET_CHANNEL_ERROR,
} from "./actionType";

const INIT_STATE = {
  channel: {},
  error: "",
  isChannelLoading: false,
};

const Channel = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Common Success
    case CHANNEL_API_RESPONSE_SUCCESS:
      return {
        ...state,
        channel: action.payload,
      };

    // Common Error
    case CHANNEL_API_RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    // Common Loading State
    case UPDATE_CHANNEL_LOADING:
      return {
        ...state,
        isChannelLoading: action.payload,
      };

    // Common Reset Error
    case RESET_CHANNEL_ERROR:
      return {
        ...state,
        error: "",
      };

    default:
      return { ...state };
  }
};

export default Channel;
